import React from 'react'
import DateTime from '/app/src/lib/DateTime';
import {Tooltip} from 'react-tippy';
import {Flex, MarkdownDisplay} from '/app/src/component';

import style from './style.css'

export default class NormalMessage extends React.Component {

    render() {
        const entry = this.props.entry;
        const direction = this.props.direction;
        const position = this.props.position;
        let tooltipDirection = direction;
        const body = entry.entry_body || '';
        const tooltipHtml = <div style={{fontSize: "15"}}> {DateTime.getDetailedNiceDate(entry.date_created)} </div>;

        return (
                <Flex className={style.normal} hAlignContent={direction} column>
                    {
                        this.props.name &&
                        <div className={style['MessageInfoName-'+direction]}>
                           {this.props.name}
                        </div>
                    }

                    <Tooltip html={tooltipHtml} position={tooltipDirection}
                                animation='none'
                                duration={0}
                                hideDelay={0}
                                theme='transparent'
                                size='large'
                    >
                        <Flex className={`${style.NormalBody} ${style[direction]} ${style[position]}`} column>
                            <MarkdownDisplay text={body}/>
                                {
                                    this.props.image &&
                                    <img src={this.props.image} alt='message-info-avatar' className={style['MessageInfoAvatar-'+direction]}/>
                                }
                        </Flex>
                    </Tooltip>
                </Flex>
        );
    }
}



// WEBPACK FOOTER //
// ./src/component/Conversation/Message/Normal.js